module.exports = __webpack_public_path__ + "img/vyttra_preparing_results.45bc2858.png";